<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 d-flex flex-column h-100">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="144"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
    @if (!isLoading) {
      <ziro-datatable
        [class]="'ziro-card'"
        [dataAutomation]="tableDataAutomation"
        [columns]="datatableCols"
        [rowDataSource]="datatableRows"
        [uniqueRowIdentifier]="'guid'"
        [mainFilterPlaceholder]="'tkey;reports.microsoft.misconfigured_voice_apps.table.filter.placeholder'"
        [maxLength]="150"
        [noResultsAlert]="'tkey;reports.microsoft.misconfigured_voice_apps.table.no_results_message'"
        [noResultsAlertClass]="!datatableRows.length && 'table-success'"
        [stickyColumnCount]="1"
      >
        <ziro-datatable-multi-select-filter
          [label]="'tkey;reports.microsoft.misconfigured_voice_apps.table.filter.voice_application_type.label'"
          [items]="voiceAppTypeFilterOptions"
          [matchFn]="voiceAppTypeFilterMatch"
          [dataAutomation]="'voice-app-type-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-multi-select-filter>
      </ziro-datatable>
    }
  </div>
</div>
<ziro-bottom-nav></ziro-bottom-nav>
